export default function TJCaptcha({ store, message }) {
  return new Promise((resolve, reject) => {
    if (store.state.otherSetting.is_captcha == 0) {
      return resolve({});
    }
    try {
      const isCzScenes = location.hostname.includes('czmstt');
      let appId = '';
      if (process.env.BUILD_ENV === 'prod') {
        appId = isCzScenes ? '198611239' : '194929999';
      } else {
        appId = isCzScenes ? '198563194' : '198676495';
      }
      // 生成一个验证码对象
      var captcha = new window.TencentCaptcha(
        appId,
        (res) => {
          if (res.ret == 0) {
            if (res.errorMessage) {
              message({
                message: res.errorMessage,
                type: 'error',
              });
              reject();
              return;
            }
            resolve(res);
          } else {
            reject();
          }
        },
        {
          needFeedBack: false,
        },
      );
      // 调用方法，显示验证码
      captcha.show();
    } catch (error) {
      reject();
    }
  });
}
